import { InputAdornment } from "@mui/material";
import { useChannels } from "api/channels";
import { NumberFormatInput } from "components/FormControls/NumberFormatInput";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { SelectInput } from "components/FormControls/Select/Select";
import { useMessage } from "hooks/intl";
import { useManageInfiniteScroll } from "hooks/useManageInfiniteScroll";
import { get } from "lodash";
import { TransactionPercentInChannel as TransactionPercentInChannelType } from "types/segments";
import { BoxElement } from "./BoxElement";
import { useStyles } from "./SegmentConditions.styles";

export const initialValuesTransactionPercentInChannel: TransactionPercentInChannelType =
  {
    percent: 0,
    channelId: "",
    type: "transaction_percent_in_channel",
  };

export function TransactionPercentInChannel({
  formField,
  values,
  status,
  readOnly,
}: {
  formField: string;
  values: any;
  status: any;
  readOnly?: boolean;
}) {
  const classes = useStyles();
  const { message } = useMessage();
  const { useInfiniteChannelsList } = useChannels();

  const {
    data: infiniteChannelsList,
    size: channelsSize,
    setSize: setChannelsSize,
    isValidating,
  } = useInfiniteChannelsList({ order: "asc", sortKey: "name" });

  const { infiniteData: channelsList, anyElementsToFetch: anyChannelsToFetch } =
    useManageInfiniteScroll(infiniteChannelsList || []);

  const channelsItems = channelsList.map((channel) => {
    return {
      id: channel.channelId,
      label: channel.name,
    };
  });

  const value = get(values, formField);
  const channelIdError = get(status, "channelId");
  const percentError = get(status, "percent");

  return (
    <>
      {value.isConditionSaved || readOnly ? (
        <>
          <BoxElement
            content={
              channelsItems.find((item) => item.id === value.channelId)
                ?.label || value.channelId
            }
            error={channelIdError}
          />
          {message({ id: "is_equal" }).toLocaleLowerCase()}
          <BoxElement content={`${value?.percent}%`} error={percentError} />
        </>
      ) : (
        <>
          <SelectInput
            className={classes.input}
            items={channelsItems}
            label={message({ id: "channel" })}
            name={`${formField}.channelId`}
            data-test-id="segment-conditions-transaction-percent-in-channel-channel-select-input"
            anyElementsToFetch={anyChannelsToFetch}
            loadMoreElements={() =>
              !isValidating && setChannelsSize(channelsSize + 1)
            }
          />
          <NumberFormatInput
            allowNegative={false}
            className={classes.input}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            label={<RequiredFieldLabel text={message({ id: "percent" })} />}
            name={`${formField}.percent`}
            data-test-id="segment-conditions-transaction-percent-in-channel-percent-input"
          />
        </>
      )}
    </>
  );
}
